import { useTranslation } from "react-i18next";

import { rememberLocaleChoice } from "@/features/preferences/store";
import { ADMIN_LOCALES, isAdminLocale } from "@/i18n";
import { cn } from "@/lib/utils";

/** Endonyms are never translated. */
const ENDONYM = { ja: "日本語", th: "ไทย", en: "English" } as const;

/**
 * Staff UI language (T11-03): switches every text at once without reloading, is remembered on
 * this device (localStorage) and saved to the person's account (`PATCH /v1/auth/me {locale}`,
 * T01-17) — their other computers switch too; picked on the sign-in page → saved at sign-in.
 */
export function LanguageSelect({ size = "sm" }: { size?: "sm" | "lg" }) {
  const { t, i18n } = useTranslation();
  const current = isAdminLocale(i18n.resolvedLanguage) ? i18n.resolvedLanguage : "en";
  return (
    <label className="flex items-center gap-1 text-sm">
      <span className="sr-only">{t("app.language")}</span>
      <select
        aria-label={t("app.language")}
        value={current}
        onChange={(e) => {
          const next = e.target.value;
          void i18n.changeLanguage(next);
          if (isAdminLocale(next)) {
            rememberLocaleChoice(next);
          }
        }}
        className={cn(
          "rounded-md border bg-background px-2",
          size === "lg" ? "min-h-touch w-full max-w-xs text-base" : "min-h-touch",
        )}
        data-slot="language-select"
      >
        {ADMIN_LOCALES.map((code) => (
          <option key={code} value={code} lang={code}>
            {ENDONYM[code]}
          </option>
        ))}
      </select>
    </label>
  );
}
